import Modal from "react-bootstrap/Modal";
import { useLanguage } from "../i18n/LanguageContext";

export default function EvidenceModal({
  show,
  onHide,
  title,
  children,
  wide = false,
}) {
  const { t } = useLanguage();
  return (
    <Modal
      show={show}
      onHide={onHide}
      size={wide ? "xl" : "lg"}
      centered
      scrollable
      className="evidence-modal"
      aria-label={title}
    >
      <Modal.Header>
        <Modal.Title as="h2">{title}</Modal.Title>
        <button
          type="button"
          className="evidence-close"
          onClick={onHide}
          aria-label={t("evidence.close")}
        >
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
}
